import { ICopyable, IJsonSerializable, IOpChangeState } from '../util/interfaces'
import { OpDescr } from './op-descr'
import { Enums } from '../common/enums'

export class OpNotificationDeliveryType implements IOpChangeState, IJsonSerializable, ICopyable<OpNotificationDeliveryType> {

    // #region Properties

    public idNotificationDeliveryType: number
    public name: string
    public idDescr: number

    // #endregion


    // #region Navigation Properties

    public descr: OpDescr

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpNotificationDeliveryType) {
            this.copy(<OpNotificationDeliveryType>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #endregion IJsonSerializable implementation
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idNotificationDeliveryType = opObj.ID_NOTIFICATION_DELIVERY_TYPE
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR,
            this.opState = opObj.OpState,
            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
        } else {
            this.idNotificationDeliveryType = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_NOTIFICATION_DELIVERY_TYPE: this.idNotificationDeliveryType,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            OpState: this.opState
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): any {
        const notificationDeliveryType: OpNotificationDeliveryType = new OpNotificationDeliveryType()

        notificationDeliveryType.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return notificationDeliveryType
    }

    public copy(source: OpNotificationDeliveryType, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.descr = source.descr != null ? source.descr : null // zaimplementować ICopyable w OpDescr
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idNotificationDeliveryType = source.idNotificationDeliveryType
        this.name = source.name
        this.idDescr = source.idDescr

        this.opState = source.opState
    }

    // #endregion
}